import React, { useContext } from 'react';
import { ModalBody } from 'reactstrap';
import { DaylightContext } from '../DaylightCodeMapper';
import CodesTable from './CodesTable/CodesTable';
import CodesTableFooter from './CodesTableFooter/CodesTableFooter';
import './CodeMapperBody.css';

const CodeMapperBody = () => {
    // TODO: make sure context values are working correctly
    const { canFlagForReview, canManageDaylightSync, canReview } =
        useContext(DaylightContext);
    // ??? TODO: what are these checks this seems unecessary / broken
    let review = canFlagForReview || canManageDaylightSync; // this was broken "MarkForReview" didn't exist but I replaced with FlagForReview
    review = review && !canReview;
    return (
        <ModalBody>
            <div
                className="code-mapper-body"
                style={{
                    maxHeight: '70vh',
                    minHeight: '70vh'
                }}>
                <CodesTable review={review}/>
            </div>

            <CodesTableFooter />
        </ModalBody>
    );
};

export default CodeMapperBody;
